import { useEffect, useState } from 'react'

/**
 * true solo cuando `loading` lleva mas de `ms` en true. Evita enseñar el
 * indicador de carga en peticiones que terminan enseguida (parpadeo).
 */
export const useDelayedLoading = (loading: boolean, ms = 400): boolean => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!loading) {
      setVisible(false)
      return
    }

    const temporizador = setTimeout(() => setVisible(true), ms)
    return () => clearTimeout(temporizador)
  }, [loading, ms])

  return visible
}
